module.exports = __webpack_public_path__ + "img/wsxx.d893a212.png";